module.exports = __webpack_public_path__ + "static/media/paso 5.15310e10.png";